// extracted by mini-css-extract-plugin
export var legendIndicator = "_by-1";
export var legendRight = "_by-0";